<quill-editor [className]="'notranslate'" [modules]="editorModules" #editor a3l-ui-input [placeholder]="'Wpisz' | translate" (onContentChanged)="contentChanged($event)" (onFocus)="focusin()" (onBlur)="focusout()"></quill-editor>
